@if (servicio.conjuntos().length > 0) {
  <p-iconfield class="eq-select__icon-field selector-conjunto">
    <p-inputicon class="pi pi-building" />
    <p-select
      inputId="selector-conjunto"
      [ariaLabel]="t().conjunto"
      [placeholder]="t().conjunto"
      [options]="servicio.conjuntos()"
      optionLabel="name"
      optionValue="id"
      appendTo="body"
      [ngModel]="servicio.activoId()"
      (ngModelChange)="servicio.seleccionar($event)"
      styleClass="eq-select__control"
    />
  </p-iconfield>
}
